<template>
  <b-modal
    :title="title"
    :size="size"
    ok-title="Save"
    :no-close-on-backdrop="true"
    @ok="ok"
    @hide="hide"
    @shown="shown"
    modal-class="image-cropper-modal"
    ref="modal"
  >
    <b-row>
      <slot :image="image" />
      <b-col class="p-5">
        <div>
          <h5>{{ imageTitle }}</h5>
          <img :src="image" class="img-fluid" ref="image" v-if="image" />
          <b-button-group class="button d-flex align-items-center">
            <b-button @click="cropper.zoom(-0.1)">
              <font-awesome-icon :icon="['fas', 'minus-circle']" />
            </b-button>
            <b-form-input
              type="range"
              class="m-1"
              min="0"
              max="1"
              step="0.01"
              v-model="zoom"
            ></b-form-input>
            <b-button @click="cropper.zoom(0.1)">
              <font-awesome-icon :icon="['fas', 'plus-circle']" />
            </b-button>
          </b-button-group>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";

export default {
  props: ["title", "size", "imageTitle", "image", "aspectRatio"],
  data() {
    return {
      cropper: null,
      zoom: null
    };
  },
  beforeDestroy() {
    // cropperjs listens to window resize until destroyed.
    if (this.cropper) {
      this.cropper.destroy();
    }
  },
  methods: {
    makeCropper() {
      this.$refs.modal.show();
    },
    ok() {
      this.cropper.getCroppedCanvas().toBlob(blob => {
        this.$emit("crop", URL.createObjectURL(blob));
      });
    },
    hide(event) {
      if (event.trigger === "ok") {
        return;
      }

      this.$emit("cancel", event);
    },
    shown() {
      if (this.cropper) {
        this.cropper.destroy();
      }

      this.cropper = new Cropper(this.$refs.image, {
        viewMode: 1,
        dragMode: "move",
        aspectRatio: this.aspectRatio,
        ready: () => {
          const { width, naturalWidth } = this.cropper.getImageData();
          this.zoom = width / naturalWidth;
        },
        zoom: event => {
          if (event.detail.ratio > 1) {
            event.preventDefault();
            this.cropper.zoomTo(1);
            return;
          }

          this.zoom = event.detail.ratio;
        }
      });
    }
  }
};
</script>

<style lang="scss">
// b-modal renders into <body>, so target it through modal-class. Not
// "cropper-modal": cropperjs already uses that for its dark overlay.
.modal.image-cropper-modal {
  .modal-header,
  .modal-footer {
    justify-content: center;
    border: 0;

    .modal-title {
      position: fixed;
    }
  }
}
</style>

<style lang="scss" scoped>
.button {
  max-width: 200px;
  margin: 0 auto;
}
</style>
